import React, { useEffect, useState, Fragment, useRef } from "react";
import { DailyCropRecoReportContent } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const feildAvailabeDedauctionTypes = this.props.feildAvailabeDedauctionTypes;
        const weighDedauctionTypesTable = this.props.weighDedauctionTypesTable;
        const weighAvailabeDedauctionTypes = this.props.weighAvailabeDedauctionTypes;
        const dynamicDeductionTotal = this.props.dynamicDeductionTotal;
        const totalValues = this.props.totalValues;
        return (
            <div>
                <h3 className="pr-2"><center><u>Daily Crop Reconcilliation Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>Type: </b> {searchData.type}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                <table
                    id="examplePdf"
                    className="display dataTable">
                    <thead>
                        <tr>
                            <th rowSpan="2">Route Name</th>
                            <th rowSpan="2">Reg. Number</th>
                            <th rowSpan="2">Customer Name</th>
                            <th rowSpan="2">Route Tag</th>
                            <th rowSpan="2">Factory Tag</th>
                            <th colSpan={feildAvailabeDedauctionTypes.length + 2} scope="colgroup">Field</th>
                            <th colSpan={weighAvailabeDedauctionTypes.length + 2} scope="colgroup">Factory Weigh</th>
                            <th rowSpan="2">Gross Variance</th>
                            <th rowSpan="2">Gain/Loss</th>
                        </tr>
                        <tr>
                            {/* <th scope="col">Actual Amount (Kg)</th> */}
                            <th scope="col">Gross Amount (Kg)</th>
                            {feildAvailabeDedauctionTypes.map((data, index) => {
                                return (
                                    <th scope="col" key={index}>{data}</th>
                                );
                            })}
                            <th scope="col">Net Amount (Kg)</th>
                            {/* <th scope="col">Actual Amount (Kg)</th> */}
                            <th scope="col">Gross Amount (Kg)</th>
                            {weighDedauctionTypesTable.map((data, index) => {
                                return (
                                    <th scope="col" key={index}>{data}</th>
                                );
                            })}
                            <th scope="col">Net Amount (Kg)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <DailyCropRecoReportContent
                            data={resultData}
                            contentRowNames={contentRowNames}
                            hasEdit={false}
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan="5" style={{ textAlign: "center" }}>Total</th>
                            {/* <th style={{ textAlign: "right" }}>{totalValues.feildActualTot}</th> */}
                            <th style={{ textAlign: "right" }}>{totalValues.feildGrossTot}</th>

                            {feildAvailabeDedauctionTypes.map((data, index) => {
                                let feild = dynamicDeductionTotal.find(o => o.name === data);
                                if (feild === undefined || feild === null) {
                                    return (
                                        <th key={index} style={{ textAlign: "right" }}>0.00</th>
                                    );
                                } else {
                                    return (
                                        <th key={index} style={{ textAlign: "right" }}>{feild.value.toFixed(2)}</th>
                                    );
                                }
                            })}

                            <th style={{ textAlign: "right" }}>{totalValues.feildNetTot}</th>
                            {/* <th style={{ textAlign: "right" }}>{totalValues.factoryActualTot}</th> */}
                            <th style={{ textAlign: "right" }}>{totalValues.factoryGrossTot}</th>

                            {weighDedauctionTypesTable.map((data, index) => {
                                let factory = dynamicDeductionTotal.find(o => o.name === "f" + data);
                                if (factory === undefined || factory === null) {
                                    return (
                                        <th key={index} style={{ textAlign: "right" }}>0.00</th>
                                    );
                                } else {
                                    return (
                                        <th key={index} style={{ textAlign: "right" }}>{factory.value.toFixed(2)}</th>
                                    );
                                }
                            })}

                            <th style={{ textAlign: "right" }}>{totalValues.factoryNetTot}</th>
                            <th style={{ textAlign: "right" }}>{totalValues.grossVariancetot}</th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}